import { render, staticRenderFns } from "./NotSign.vue?vue&type=template&id=401a2855&scoped=true&"
import script from "./NotSign.vue?vue&type=script&lang=js&"
export * from "./NotSign.vue?vue&type=script&lang=js&"
import style0 from "./NotSign.vue?vue&type=style&index=0&id=401a2855&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401a2855",
  null
  
)

export default component.exports